module.exports = __webpack_public_path__ + "img/play-alt.90a2bc63.svg";